import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

import { onPageJump, isRecurringPaymentDetailsHidden } from '../WMICSidebarNavigationUtil'
import styles from './MobileWizardSteps.module.scss';

function renderSteps(steps, currentStepIndex, wizardContext, viewModelService) {

    return steps.map((step, index) => {
        const isStepHidden = step.hideFromSidebar || isRecurringPaymentDetailsHidden(step, steps[currentStepIndex]);

        const liClassName = classNames(styles.step, {
            [styles.visited]: index < currentStepIndex,
            [styles.active]: index === currentStepIndex,
            [styles.notVisited]: !step.visited || index > currentStepIndex,
            [styles.hidden]: isStepHidden
        });
        return <li className={liClassName} key={step.id} onClick={() => onPageJump(index, wizardContext, viewModelService)} />;
    });
}

function MobileWizardSteps(props) {
    const wizardContext = useContext(WizardContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { toggleSideBar } = props;
    const { steps, currentStepIndex} = wizardContext;

    return (
        <div className={styles.navigationButton} onClick={toggleSideBar}>
            <ul className={styles.stepContainer} role="navigation">
                {renderSteps(steps, currentStepIndex, wizardContext, viewModelService)}
            </ul>
        </div>
    );
}

MobileWizardSteps.propTypes = {
    toggleSideBar: PropTypes.func.isRequired
};
export default MobileWizardSteps;
